import type { BookingValueLimit, BookingValueOddsTypeLimit } from '@/types/booked-bet';
import { OperationType } from '@/types/booked-bet';
import { WebOddsType, IncDecType } from '@nf/utils-common/constants';
import { idealRound } from '@nf/utils-common/numbers';
import BookingStrategy from './booking-strategy';

class BookingManager {
	private strategy: BookingStrategy;

	constructor(strategy: BookingStrategy) {
		this.strategy = strategy;
	}

	generateStepSize(value: number): number {
		return this.strategy.generateStepSize(value);
	}

	getOddsTypeLimit(value: number = 0): BookingValueOddsTypeLimit {
		return this.strategy.getOddsTypeLimit(value);
	}

	calculateDefaultRange(value: number, incDecType: IncDecType): Array<number> {
		return this.strategy.calculateDefaultRange(value, incDecType);
	}

	calculateDefaultLimit(value: number, incDecType: IncDecType): BookingValueLimit {
		const range: Array<number> = this.calculateDefaultRange(value, incDecType);

		return {
			min: idealRound(range[0] ?? 0, 2),
			max: idealRound(range[range.length - 1] ?? 0, 2)
		};
	}

	calculateBookingOdds(
		odds: number, 
		operationType: OperationType, 
		baseOddsType?: WebOddsType
	) {
		return this.strategy.calculateBookingOdds(odds, operationType, baseOddsType);
	}
}

export default BookingManager;